// extracted by mini-css-extract-plugin
export default {"root":"ReportContentModal_root__Pl9T4","container":"ReportContentModal_container__vL4Gy","body":"ReportContentModal_body__jOinc"};